import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from 'aurelia-dependency-injection';
import { StringUtilities } from '../../../utilities/strings';
import { AttachmentsHelper } from '../../../utilities/attachments-helper';
import { computedFrom } from 'aurelia-binding';
import { Reflection } from '../../../utilities/reflection';

@autoinject()
export class ImageViewer {

    private rotate: number = 0;
    private scale: number = 1;
    
    public isLoading: boolean;
    public type: string;
    public url: string;
    public imageElement: HTMLImageElement;
    public imageScaleElement: HTMLImageElement;
    public zoomAmount: number = 100;
    public maxZoomOut: number = 20;
    public maxZoomIn: number = 200;
    public scaleAmount: number = 20;

    constructor(private dialogClientService: DialogClientService) { }

    @computedFrom(Reflection.getPropertyPath<ImageViewer>(z => z.zoomAmount), Reflection.getPropertyPath<ImageViewer>(z => z.maxZoomIn))
    get canZoomIn() {
        return this.zoomAmount < this.maxZoomIn; 
    }

    @computedFrom(Reflection.getPropertyPath<ImageViewer>(z => z.zoomAmount), Reflection.getPropertyPath<ImageViewer>(z => z.maxZoomOut))
    get canZoomOut() {
         return this.zoomAmount > this.maxZoomOut;
    }

    activate(params) {

        if (!params) {
            return;
        }

        this.type = params.link;
        this.url = params.isDataUrl ? params.link : AttachmentsHelper.getUrl(params.link);

        if (params.isDataUrl || !StringUtilities.startsWith(this.url, location.origin)) {
            this.isLoading = false;
        } else {
            const inerval = setInterval(() => {
                $.ajax({
                    type: 'HEAD',
                    url: this.url,
                    success: () => {
                        this.url += ("?" + Math.random());
                        clearInterval(inerval);
                        setTimeout(() => {
                            this.isLoading = false;
                        });
                    }
                });
            }, 3000);
        }
    }

    public execCommand(command) {
        switch (command) {
            case "restore": {
                this.scale = 1;
                this.rotate = 0;
                this.zoomAmount = 100;
            }
                break;
            case "zoom-in": {
                if(this.zoomAmount < this.maxZoomIn){
                    this.scale += this.scaleAmount / 100;
                    this.zoomAmount += this.scaleAmount;
                }
            }
                break;
            case "zoom-out": {
                if(this.zoomAmount > this.maxZoomOut){
                    this.scale -= this.scaleAmount / 100;
                    this.zoomAmount -= this.scaleAmount;
                }
            }
                break;
            case "rotate-right": {
                this.rotate += 90 % 360;
            }
                break;
            case "rotate-left": {
                this.rotate -= 90 % 360;
            }
                break;
        }

        this.imageScaleElement.style.transform = `scale(${this.scale})`;
        this.imageElement.style.transform = `rotate(${this.rotate}deg)`;
    }

    public goBack() {
        this.execCommand('restore');
        this.dialogClientService.hide();
    }
}
